const REASON_KEYS = {
    missing_email: 'missingEmail',
    invalid_email: 'invalidEmail',
    invalid_name: 'invalidName',
    invalid_phone: 'invalidPhone',
    missing_role: 'missingRole',
    invalid_role: 'invalidRole',
    missing_mandatory_fields: 'missingMandatoryFields',
    missing_customer_name: 'missingCustomerName',
    invalid_customer_type: 'invalidCustomerType',
    multiple_customers_share_name: 'multipleCustomersShareName',
    customer_id_not_found: 'customerIdNotFound',
    matches_sample_customer: 'matchesSampleCustomer',
    matches_archived_customer: 'matchesArchivedCustomer',
    processing_error: 'processingError'
};
const reasonTextFor = (reason, texts)=>{
    const key = Object.hasOwn(REASON_KEYS, reason) ? REASON_KEYS[reason] : undefined;
    return key == null ? texts.rejectionReason.processingError() : texts.rejectionReason[key]();
};
export const rejectionLine = (param, texts)=>{
    let { reason, rowNumber, contact } = param;
    const reasonText = reasonTextFor(reason, texts);
    if (contact == null) return reasonText;
    const { firstName, lastName, email } = contact;
    const hasName = firstName.trim().length > 0 || lastName.trim().length > 0;
    const hasEmail = email.trim().length > 0;
    if (hasName && hasEmail) {
        return texts.rejectionLine.withNameAndEmail({
            firstName,
            lastName,
            email,
            reason: reasonText
        });
    }
    if (hasName) return texts.rejectionLine.nameOnly({
        firstName,
        lastName,
        reason: reasonText
    });
    if (hasEmail) return texts.rejectionLine.emailOnly({
        email,
        reason: reasonText
    });
    return texts.rejectionLine.rowNumber({
        rowNumber,
        reason: reasonText
    });
};
